import React, { useContext, useEffect, useState } from "react";
import "./styles.css";
import { Breadcrumb, ProfileInfoCard } from "../../Components/Atoms";
import { useNavigate, useSearchParams } from "react-router-dom";
import { StoreContext } from "../../Library/contexts";
import PATHS from "../../Routes/paths";
import { getUserAndVehicleDetails } from "../../APIs";
import { Button, Tooltip } from "@chakra-ui/react";
import { AddModelIcon, PenIcon } from "../../Assets/images/svgs";
import { RealtimeVehicleStatusTable } from "../../Components/Organisms";

const SubUserInfo = () => {
  const [ searchParams ] = useSearchParams();
  const { allSubUsers, setAllSubUsers, userVehicles } = useContext(StoreContext);
  const [ selectedUser, setSelectedUser ] = useState(null);
  const navigate = useNavigate();

  const handleSelectedSubUser = (subUsers) => {
    let mob = +searchParams.get("mob");
    if (mob) {
      let userToShow = (subUsers || allSubUsers).find(user => user.mob === mob);
      if (userToShow && userToShow.mob) setSelectedUser(userToShow);
    } else {
      let url = PATHS.SUB_USERS;
      if (searchParams.get("fromAssignVehs")) url += `?fetchSubUsers=1`;
      navigate(url);
    }
  }

  useEffect(() => {
    if (allSubUsers && allSubUsers.length) {
      handleSelectedSubUser();
    } else {
      getUserAndVehicleDetails({}, (err, data=[]) => {
        if (err) console.error("Error fetching sub users");
        else {
          const updatedData = data.map((user) => ({
            ...user,
            nm: `${user.fn || ""} ${user.mn || ""} ${user.ln || ""}`.trim(),
          }));
          setAllSubUsers(updatedData);
          handleSelectedSubUser(updatedData);
        }
      });
    }
  }, [ allSubUsers, searchParams, setAllSubUsers ]);

  const breadcrumbPaths = [
    { idx: 1, name: "Subusers", link: "/sub-users" },
    { idx: 2, name: `${(selectedUser && selectedUser.fn) || "Sub user"}`, isCurrentPage: true },
  ];

  const subuser_dets = [
    { label: "Subuser Name", value: selectedUser?.nm || "NA" },
    { label: "Contact Number", value: selectedUser?.mob || "NA" },
    { label: "Email Address", value: selectedUser?.eml || "NA" },
    { label: "Vehicles Assigned", value: selectedUser?.vehCnt || "NA" },
  ]

  const profileCardEditBtn = <Button leftIcon={<PenIcon />} className="edit-subuser-btn" iconSpacing={1} variant={"outline"} onClick={() => navigate(`${PATHS.SUB_USERS}/${PATHS.CREATE_SUB_USER}?edit=true&mob=${selectedUser.mob}`)} >Edit</Button>

  return (
    <div className="panel-main sub-user-info">
      <div className="sub-user-info-header">
        <Breadcrumb paths={breadcrumbPaths} />
      </div>
      <ProfileInfoCard title={"Subuser Details"} displayData={subuser_dets} children={profileCardEditBtn} />

      <div className="sub-uses-vehicles-section">
        <Tooltip label={selectedUser?.vehCnt === userVehicles.length ? "All vehicles have been assigned" : ""}>
          <Button
            leftIcon={<AddModelIcon />}
            className="assign-vehicles"
            onClick={() => navigate(`${PATHS.SUB_USERS}/${PATHS.SUB_USER_DETS}/${PATHS.ASSIGN_VEHICLES}?mob=${selectedUser.mob}`)}
            isDisabled={selectedUser?.vehCnt === userVehicles.length}
          >
            Assign Vehicles
          </Button>
        </Tooltip>

        <RealtimeVehicleStatusTable selectedUser={selectedUser} vehicles={(selectedUser && selectedUser.vehicles) || []} />
      </div>
    </div>
  )
}

export default SubUserInfo
